<template>
	<div class="cc">
		<userMenu></userMenu>
		<div class="cc-box">
			<div class="cc-list cc-ipt">
				<div class="cc-list-item">
					<el-input placeholder="粘贴内容至此" v-model="copyTxt" size="small" type="textarea" rows="39"></el-input>
				</div>
				<div class="cc-list-item">
					<el-button type="primary" style="width: 100%;" @click="parsePromptText">解析复制至此的数据</el-button>
				</div>
			</div>
			<div class="cc-send" v-loading="loading" element-loading-text="发布中...">
				<div class="cc-title">
					创作中心 - 发布提示词
				</div>
				<el-form label-width="80px" size="small">
					<el-form-item label="发布栏目">
						<el-cascader style="width: 80%;" placeholder="请选择栏目" v-model="catids" :options="catData" :props="{ expandTrigger: 'hover' }"></el-cascader>
						<el-input v-model="catids" style="width: 18%;margin-left: 1%;" disabled></el-input>
					</el-form-item>
					<el-form-item label="词话标题">
						<el-input v-model="title" placeholder="请输入提示词的标题"></el-input>
					</el-form-item>
					<el-form-item label="图片地址">
						<el-input v-model="pic" placeholder="请输入提示词的图片地址"></el-input>
					</el-form-item>
					<el-form-item label="中文词话">
						<el-input v-model="cn" type="textarea" rows="16" placeholder="请输入提示词的中文详情"></el-input>
					</el-form-item>
					<el-form-item label="英文词话">
						<el-input v-model="en" type="textarea" rows="11" placeholder="请输入提示词的英文详情"></el-input>
					</el-form-item>
					<el-form-item label="适用场景">
						<el-input v-model="tag" placeholder="多个适用场景请用、分隔开"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" style="width: 200px;margin: 20px 0 20px 130px;" size="medium" @click="save">立即发布</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import userMenu from '@/page/public/userMenu'
	import api from '@/api/api'
	export default {
		components: {
			userMenu: userMenu
		},
		data() {
			return {
				title: '',
				pic: '',
				cn: '',
				en: '',
				tag: '',
				catData:[],
				catids:'',
				loading:false ,
				copyTxt:''
			}
		},
		methods:{
			save(){
				if(this.catids==''){
					this.$message.error('请选择栏目');
					return
				}
				if(this.title==''){
					this.$message.error('请输入标题');
					return
				}
				if(this.pic==''){
					this.$message.error('请输入图片地址');
					return
				}
				if(this.cn==''){
					this.$message.error('请输入中文提示词');
					return
				}
				/* if(this.en==''){
					this.$message.error('请输入英文文提示词');
					return
				} */
				if(this.tag==''){
					this.$message.error('请输入适用场景');
					return
				}
				let params = {
					token:api.getCookie('token'),
					pid: this.catids[0],
					cid: this.catids[1],
					title: this.title,
					pic: this.pic,
					cn: this.cn,
					en: this.en,
					tag: this.tag
				}
				this.loading = true;
				api.saveInfo(params).then(res => {
					if (res.code == 200) {
						this.loading = false;
						this.title = '';
						this.en = '';
						this.cn = '';
						this.tag = '';
						this.$message.success('保存成功');
					}
				})
			},
			parsePromptText() {
				let text = this.copyTxt;
				const lines = text.split('\n').filter(line => line.trim() !== '');
				
				let tt = lines[0].split('、');
				if(tt.length==2){
					this.title = tt[1];
				}else{
					this.title = tt[0];
				}
				this.pic = '/ai/'+this.catids[1]+'/'+tt[0]+'.jpg';
				const arr = lines[1].split(/：(.*)/);
				this.cn = arr[1]?arr[1].trimStart() : lines[1];
				this.en = lines[2].split('：')[1];
				this.tag = lines[3].split('：')[1];
			},
			getCategoryList(){
				api.getCategoryList({}).then(res=>{
					let data = res.data;
					let arry = [];
					for(let i in data){
						let obj = {
							value: data[i].id,
							label: data[i].name,
							children:[]
						}
						for(let j in data[i].children){
							let obj2 = {
								value: data[i].children[j].id,
								label: data[i].children[j].name,
							}
							obj.children.push(obj2)
						}
						arry.push(obj)
					}
					this.catData = arry;
				})
			}
		},
		created() {
			this.getCategoryList();
		}
	}
</script>

<style>
	.cc-title{
		display: none;
		font-size: 17px;
		color: #000;
		padding-bottom: 20px;
		text-align: right;
	}
	.cc-box {
		display: flex;
		padding-left: 220px;
	}

	.cc-list {
		flex: 1;
		padding: 20px;
		box-sizing: border-box;
	}
	.cc-ipt{
		
	}

	.cc-send {
		width: 600px;
		min-height: 100vh;
		background-color: #fff;
		padding: 30px;
		box-sizing: border-box;
	}

	.cc {
		width: 100%;
		min-height: 100vh;
		background-color: var(--bg3);
	}
	.cc-list-item{
		padding: 20px;
		background-color: #fff;
		border-radius: 10px;
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/page/cc.vue